import { FilesPageView } from '@/features/my-files/files-page';
import { useTutorDocumentDestinations } from '@/lib/documents/destinations';

/** « Mes fichiers » côté tuteur : contacts (élèves liés + mentorat) ET classes. */
export function TutorFilesPage() {
  const { destinations, isLoading } = useTutorDocumentDestinations();
  return <FilesPageView destinations={destinations} destinationsLoading={isLoading} />;
}
